import { defineMessages } from 'react-intl';

export default defineMessages({
    noCancellationNotes: {
        id: 'e1p.gateway.views.cancellation-detail.No notes associated with this cancellation',
        defaultMessage: 'There are no notes associated with this cancellation.'
    }
});
